<template>
  <Popover ref="addItemPopover" sizeClass="popover-large popover-no-padding" :showHeader="true" headerTitle="Add Items" placement="bottom">
    <div class="p-2">
      <FormGroup :labelColumnSize="4">
        <FormRow label="Stock">
          <FormSearchableSelect
            :options="stockLookupList"
            :value="stockId"
            :dropdownAutoWidth="true"
            @input="setItemStockId($event)"
            placeholder="Stock Code" />
        </FormRow>
        <FormRow label="Size" v-show="hasStock">
          <FormSelect v-model="glassSizeId" :options="glassSizeLookup" />          
        </FormRow>
        <FormRow label="Sheets In Block" v-show="hasGlassSize">
          <FormInputText type="number" v-model="blockSize" placeholder="Blocks" />                
        </FormRow>
        <FormRow label="Blocks" v-show="hasGlassSize">
          <FormInputText type="number" v-model="quantity" placeholder="Blocks" />        
        </FormRow>
      </FormGroup>

      <Spinner v-if="loading" />
      <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
      <FormHorizontalRule />
      <FormButton class="btn-primary btn-xxs" @click="addItems" :disabled="!canAddItems">Add Items</FormButton>
    </div>
  </Popover>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'

import Popover from '@/components/popover'

import { } from '@/store/types'

export default {
  name: 'RecvItemAddItemsPopover',
  mixins: [form],
  components: {
    Popover
  },
  props: {
    stockLookupList: Array
  },
  computed: {
    hasStock() {
      return this.stockId != null
    },
    hasGlassSize() {
      return this.glassSizeId != null
    },
    glassSizeLookup() {
      return this.glassSizeList.map(glassSize => {
        return {
          value: glassSize.id,
          name: `${glassSize.height} x ${glassSize.width}`
        }
      })
    },
    canAddItems() {
      return this.stockId && this.glassSizeId && this.blockSize > 0 && this.quantity > 0
    }
  },
  watch: {
    glassSizeId: function() {
      let size = this.glassSizeList.find(glassSize => glassSize.id == this.glassSizeId)
      if(size) {
        this.blockSize = size.blockSize
      }
    }
  },
  data() {
    return {
      stockId: null,
      glassSizeId: null,
      blockSize: 0,
      quantity: 0,
      stock: {},
      glassSizeList: [],
      loading: false,
      loadingError: ''
    }
  },
  created() {
  },
  methods: {
    displayFromElement(element) {
      
      this.$refs.addItemPopover.displayFromElement(element)
    },
    setItemStockId(stockId) {
      this.stockId = stockId
      this.stock = null
      this.glassSizeId = null
      this.glassSizeList = []

      if(stockId == null) {
        return
      }

      this.loading = true
      this.loadingError = ''

      // Query the stock info     
      this.$apiService.inventoryService.getStock(this.stockId)
      .then(response => {
        this.stock = response.data
        // Glass sizes
        this.glassSizeList = response.data.glassSizeList.filter(glassSize => glassSize.isActive)

        if(this.glassSizeList.length > 0)
          this.glassSizeId = this.glassSizeList[0].id
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
    addItems() {
      this.$emit('addItems', {
        stockId: this.stockId,
        stock: this.stock,
        glassSizeId: this.glassSizeId,
        glassSizeList: this.glassSizeList,
        glassSize: this.glassSizeList.find(glassSize => glassSize.id == this.glassSizeId),
        blockSize: this.blockSize,
        quantity: this.quantity
      })
      this.$refs.addItemPopover.hidePopover()
    }
  }
}
</script>